import React, { useEffect, useState, useCallback } from "react";
import Menu from "./Menu/Menu";
import useSize from "../../../Utils/useSize/useSize";
import Backend from "../../../Backend/Backend";
import toast from "react-hot-toast";
import Loading from "../../../Utils/Loading/Loading";
import useSound from "use-sound";
import Error from "../../../Sound/Error.wav";
import NotFound from "../../../Utils/NotFound/NotFound";
import LoginHistoryCard from "./LoginHistoryCard";
import moment from "moment";
import Filter from "./Filter/Filter";

const backend = await new Backend().init();

export default function LoginLogs({ user_id }) {
  const [play] = useSound(Error);
  const windowSize = useSize();

  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);

  const [start, setStart] = useState(
    moment().startOf("week").format("YYYY-MM-DD 00:00:00")
  );
  const [end, setEnd] = useState(
    moment().endOf("week").format("YYYY-MM-DD 23:59:59")
  );

  // -----------------------------
  // FETCH HISTORY
  // -----------------------------
  const loadLoginHistory = useCallback(
    async (s = start, e = end) => {
      setLoading(true);

      const data = {
        server: localStorage.getItem("server"),
        id: localStorage.getItem("id"),
        username: localStorage.getItem("username"),
        token: localStorage.getItem("token"),
        user_id,
        start: s,
        end: e,
      };

      try {
        const r = await backend.loginhistory(data);
        setLoading(false);

        if (r.error === "False") {
          setHistory(r.history || []);
        } else {
          play();
          toast.error(r.message);
        }
      } catch (err) {
        setLoading(false);
        play();
        toast.error("Network Error");
      }
    },
    [user_id, start, end, play]
  );

  // -----------------------------
  // FIRST LOAD
  // -----------------------------
  useEffect(() => {
    loadLoginHistory();
  }, [loadLoginHistory]);

  // -----------------------------
  // FILTER HANDLER
  // -----------------------------
  const handleFilter = (a, b) => {
    const s = moment(a).format("YYYY-MM-DD 00:00:00");
    const e = moment(b).format("YYYY-MM-DD 23:59:59");

    setStart(s);
    setEnd(e);

    loadLoginHistory(s, e);
  };

  // -----------------------------
  // RENDER UI
  // -----------------------------
  return (
    <div style={{ width: windowSize[0] - 100, height: windowSize[1] - 170 }}>
      <Filter
        records={history.length}
        loadLoginHistory={handleFilter}
        history={history}
        start={start}
        end={end}
      />

      <Menu />

      <div
        key={history}
        className="flex flex-col"
        style={{ height: windowSize[1] - 260, width: windowSize[0] - 100 }}
      >
        {loading ? (
          <Loading height={windowSize[1] - 260} />
        ) : history.length > 0 ? (
          <div
            className="overflow-y-scroll w-full"
            style={{ height: windowSize[1] - 260, width: windowSize[0] - 100 }}
          >
            {history.map((item) => (
              <LoginHistoryCard key={item.id} item={item} />
            ))}
          </div>
        ) : (
          <NotFound
            height={windowSize[1] - 260}
            title="Nothing here"
            subtext="No Login Logs Found."
          />
        )}
      </div>
    </div>
  );
}
